import React, { useEffect, useState } from 'react'
import { Switch } from 'antd'
import { useSelector } from 'react-redux'

import { ApplicationState } from 'src/store'
import { Button, PageHeader, Table } from 'src/components/Ant'
import { Id, Policy } from 'src/types'
import * as PoliciesService from 'src/services/api/policies'
import history from 'src/config/routes/history'
import useDocumentTitle from 'src/hooks/use-document-title'

import * as CSS from './styles'

export default function Policies() {
  useDocumentTitle('web.policies.title-plural')
  const { me } = useSelector((state: ApplicationState) => ({
    me: state.me
  }))

  const [list, setList] = useState<Policy[]>([])
  const [loading, setLoading] = useState(false)
  const [savingId, setSavingId] = useState<Id>()
  const [totalResult, setTotalResult] = useState(0)
  const [currentPage, setCurrentPage] = useState(1)

  useEffect(() => {
    let isSubscribed = true
    setLoading(true)
    PoliciesService.getAll({
      organization_id: me.organization.organization_id,
      page: currentPage,
      withInactive: true
    })
      .then(response => {
        if (isSubscribed && response.data) {
          setTotalResult(response.data.total_results)
          setList(response.data.policies)
        }
      })
      .finally(() => {
        if (isSubscribed) {
          setLoading(false)
        }
      })
    return () => {
      isSubscribed = false
    }
  }, [currentPage, me.organization.organization_id])

  return (
    <>
      <PageHeader
        extra={[
          <Button
            key="common.actions.add"
            onClick={() => {
              history.push('/policies/create')
            }}
            size="default"
            title="common.actions.add"
            type="primary"
          />
        ]}
        title="web.policies.title-plural"
      />
      <CSS.Content>
        <Table
          className="table-striped"
          columns={[
            {
              dataIndex: 'name',
              title: 'web.policies.name'
            },
            {
              title: 'common.active',
              dataIndex: 'active',
              render: (value: boolean, policyItem) => (
                <Switch
                  loading={savingId === policyItem.policy_id}
                  onClick={(_, e) => e.stopPropagation()}
                  defaultChecked={value}
                  onChange={async checked => {
                    setSavingId(policyItem.policy_id)

                    await PoliciesService.save({
                      organization_id: me.organization.organization_id,
                      policy: {
                        ...policyItem,
                        active: checked
                      }
                    })

                    setSavingId(null)
                  }}
                />
              )
            }
          ]}
          dataSource={list}
          loading={loading}
          onChange={page => {
            setCurrentPage(page.current)
          }}
          onRow={record => ({
            onClick: () => history.push(`/policies/edit/${record.policy_id}`)
          })}
          pagination={{
            current: currentPage,
            pageSize: PoliciesService.PAGE_SIZE,
            total: totalResult
          }}
        />
      </CSS.Content>
    </>
  )
}
